import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed, and NOT what the title rule derives — the second one it has
  // got wrong, after `sustainability-innovation`. The reference screenshots
  // for this book's page came from
  // `digitopia.co/impact-labs/ebooks/importance-of-measurement-for-transformation-success/`
  // on 2026-08-28, so the address is the long one and
  // `whats-measured-gets-done` (the part before the colon) was a wrong guess.
  'importance-of-measurement-for-transformation-success',
  'What’s Measured Gets Done: The Importance of Measurement for Transformation Success',
  `${UPLOADS}/2025/07/importance-of-measurement-for-transformation-success-ebook-400x400.png`,
  {
    confirmed: true,
    download: pdf(
      'e008f84d-7780-46b6-993a-ec3322b83776-The Importance of Measurement for Transformation Success.pdf',
    ),
    // Designed as its own written page on 2026-08-28, the fourth after
    // Transform Better, Agentic AI and Sustainability Innovation — so the card
    // goes there and `prerender.tsx` skips it, rather than generating this
    // template over the top of it.
    href: '/en/impact-labs/ebooks/importance-of-measurement-for-transformation-success',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 2
